<template>
  <div class="">
    <!-- show dialog -->

    <div class="flex flex-column gap-2">
      <div>
        <h4>Rutas</h4>
        <div class="flex gap-2">
          <div v-if="value.length === 0">
            No hay rutas agregadas
          </div>
          <div v-for="route in value" :key="route" class="w-full">
            <RutaDetail :doc="rutasStore.list.find((r) => r.id === route)" @click="showRouteById(route)" />
          </div>
        </div>
      </div>
      <div>

        <Button
          label="Agregar Ruta"
          size="small"
          @click="visible = true"
          class="mt-2"
        />
      </div>

    </div>
    <Dialog v-model:visible="visible" modal :style="{ width: '95vw' }" header="Seleccionar Rutas">
      <div class="grid" style="height: 85vh;">

        <div class="col-12 md:col-3 flex flex-column">
          <!-- <h2>Rutas</h2> -->
          <div
              v-for="route in rutasStore.list"
              :key="route.id"
              @click="showRoute(route)"
            >
              <RutaDetail :doc="route" :active="value.includes(route.id)" />
            </div>
        </div>
        <div class="col-12 md:col-8">
          <div class="flex flex-column gap-3 border-top-1 pt-2" v-if="activeRoute">
            <div class="flex flex-column gap-1">
              <div class="flex justify-content-between align-items-center flex-wrap">
                <h3 class="font-light m-0 p-0"
                >{{ activeRoute.name }}</h3>
                <div class="flex gap-2">
                  <Button label="Seleccionar" @click="selectRoute"  v-if="!value.includes(activeRoute.id)"/>
                  <Button label="Quitar" severity="danger" @click="removeRoute" v-else/>
                  <Button icon="pi pi-eye-slash" severity="secondary" @click="activeRoute = null" />
                </div>
              </div>

              <RutaDetail :doc="activeRoute" list />

              <div>
                {{ activeRoute.notas }}
              </div>
            </div>
            <iframe
              :src="src"
              frameborder="0"
              class="map-iframe"
              style="min-height: 60vh; width: 100%"
            ></iframe>



          </div>

        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import Dialog from 'primevue/dialog';
import RutaDetail from "./RutaDetail.vue";
import { useRutas } from "./useRutas";
import { ref, computed, defineModel } from "vue";
const {
  rutasStore,
} = useRutas();
const value = defineModel({ default: [] });
const visible = ref(false);
const activeRoute = ref(null);
const src = computed(() => {
  if (!activeRoute.value) return "";
  const center = activeRoute.value.route[0][0] + "," + activeRoute.value.route[0][1];
  return ("/mapa.html?type=route&center=" +
    center +
    "&zoom=" +
    activeRoute.value.zoom +
    "&route=" +
    JSON.stringify(activeRoute.value.route) +
    "&points=" +
    JSON.stringify(activeRoute.value.points)
)
});

const selectRoute = () => {
  visible.value = false;
  value.value = [
    ...value.value,
    activeRoute.value.id
  ]
};
const showRouteById = (id) => {
  const route = rutasStore.list.find((r) => r.id === id);
  showRoute(route);
};

const removeRoute = () => {
  value.value = value.value.filter((r) => r !== activeRoute.value.id);
};

const showRoute = (route) => {
  console.log("showRoute", route);
  activeRoute.value = null;
  visible.value = true;
  setTimeout(() => {
    activeRoute.value = route;
  }, 100);
  
};
</script>